import React from 'react';
import "./hero.css"
import { Link } from 'react-router-dom';


const Hero = () => {
    return (
        <div className="hero">
            <h1>Sustainable Waste Management Solutions</h1>
            <p>Leading the way in environmentally responsible waste management services for a cleaner, greener future.</p>
            <div className="buttons">
                <Link to="/Services">Get Started</Link>
                <Link to="/login">Learn More </Link>
                
            </div>
        </div>
    );    
   
};



export default Hero;
